<template>
  <BaseForm
    class="registry-form"
    :class="{ small: small }"
    :action="action"
    :response-to="responseTo"
    :response-text="responseText"
    gtm-submit-event="form_submit_registry"
    :dark="dark"
  >
    <template #fields>
      <input name="course" type="hidden" :value="courseId" />
      <NameField :dark="dark" />
      <TelField :dark="dark" />
      <EmailField :dark="dark" />
      <PolicyPrivacyField :dark="dark" />
    </template>

    <template #button>
      <ButtonWidget type="submit" align="center">
        <v-icon color="white" size="16" left> fas fa-paper-plane </v-icon>
        Enviar
      </ButtonWidget>
    </template>
  </BaseForm>
</template>

<script>
import BaseForm from "./BaseForm.vue";
import NameField from "./fields/NameField.vue";
import EmailField from "./fields/EmailField.vue";
import TelField from "./fields/TelField.vue";
import PolicyPrivacyField from "./fields/PolicyPrivacyField.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

export default {
  props: {
    action: {
      type: String,
      required: true,
    },
    courseId: {
      type: Number,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    responseTo: {
      type: String,
      default: "",
    },
    responseText: {
      type: String,
      default: "",
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseForm,
    NameField,
    EmailField,
    TelField,
    PolicyPrivacyField,
    ButtonWidget,
  },
};
</script>

<style lang="scss">
.registry-form {
  .base-form-fields {
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 16px;
  }
}
</style>
